import lazyImport from '../../../Utils/Loading/loadingHelpers'

const FormControlLabel = lazyImport(
  () => import(/* webpackChunkName: "mui-forms" */ '@mui/material/FormControlLabel')
)

export { FormControlLabel }
